import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Injectable()
export class ExcelExporterService {
  constructor() { }

  private EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  private EXCEL_EXTENSION = '.xlsx';

  exportComunicacionExcel(titles: any[], data: any[], excelFileName: string): void {
    const fullData = [titles, ...data, [], ['Fecha de Exportacion: ', moment(new  Date().getTime()).format('DD-MM-YY HH:mm:ss').toString()]];
    this.exportStringArrayAsExcel(fullData, excelFileName);
  }

  // exporta un Json a excel, tomando los nombres de las propiedades como los titulos.

  exportJsonAsExcel(json: any[], excelFileName: string): void {
    const wscols = [{wch: 6}];
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    worksheet['!cols'] = wscols;
    const workbook: XLSX.WorkBook = { Sheets: { 'Libro1': worksheet }, SheetNames: ['Libro1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  // exporta a excel array de string, tomando el primer array de string como Titulos y el resto como valores
  // Data es aun array de array de string, tomando cada array como una fila en el documento.
  // Util si los titulos contienen espacios.

  exportStringArrayAsExcel(data: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'Libro1': worksheet }, SheetNames: ['Libro1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.EXCEL_TYPE});
    const fecha = moment(new  Date().getTime()).format('DD-MM-YY HH:mm:ss').toString();
    FileSaver.saveAs(data, fileName + '_' + fecha + this.EXCEL_EXTENSION);
  }



}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/excel-exporter-service.ts